import { apiClient } from './api';

/**
 * Fetch pronunciation audio for a vocabulary word as an authenticated blob.
 *
 * The /vocabulary/audio route is behind JWT middleware, so a bare `new Audio(url)`
 * (which sends no Authorization header) cannot reach it. Routing through `apiClient`
 * attaches the Supabase JWT; the caller then wraps the blob in an object URL.
 *
 * Mirrors `fetchStoryAudioBlob` in storytime.service.ts.
 */
export const fetchVocabAudioBlob = async (word: string, language: string): Promise<Blob> => {
  const { data } = await apiClient.get<Blob>('/vocabulary/audio', {
    params: { word, lang: language },
    responseType: 'blob',
  });
  return data;
};
